function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.122 27.366a5.612 5.612 0 010-7.893L17.18 5.303a7.759 7.759 0 0111.034 0c3.047 3.071 3.047 8.05 0 11.121l-8.219 8.283a1.001 1.001 0 01-1.423 0 1.02 1.02 0 010-1.435l8.218-8.283a5.867 5.867 0 000-8.25 5.757 5.757 0 00-8.186 0l-14.06 14.17a3.571 3.571 0 000 5.021 3.504 3.504 0 004.983 0l14.416-14.528a1.275 1.275 0 000-1.794 1.252 1.252 0 00-1.78 0l-11.212 11.3a1.001 1.001 0 01-1.424 0 1.02 1.02 0 010-1.435l11.212-11.3a3.254 3.254 0 014.627 0 3.316 3.316 0 010 4.664L10.952 27.366a5.507 5.507 0 01-7.83 0z",
  fill: "currentColor"
})));